export default {
  id: null,
  nome: null,
  document: null,
  tipoPessoa: null,
  email: null,
  emailCorporativo: null,
  dataNascimento: null,
  siteUrl: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/personmodel.js